import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getKeywordResearchKeywords,
  getKeywordResearchHasMore,
  isFetchingKeywordResearch,
  getOffset,
  isFirstFetch,
  getSelectedResearchType,
  getKeywordResearchData
} from "../../store/keyword_research/selectors";
import { fetchKeywordResearch } from "../../store/keyword_research/operations";
import KeywordResearchTable from "../../components/KeywordResearch/KeywordResearchTable";

class KeywordResearchTableContainer extends Component {
  constructor(props) {
    super(props);

    this.onLoadMore = this.onLoadMore.bind(this);
  }

  componentDidMount() {
    if (
      this.props.keywordResearch[this.props.keyword] &&
      this.props.keywordResearch[this.props.keyword][`${this.props.selectedResearchType}:${this.props.seoDb}`]
    ) {
      return;
    }

    this.props.fetchKeywordResearch(this.props.keyword, this.props.selectedResearchType, this.props.seoDb);
  }

  onLoadMore() {
    this.props.fetchKeywordResearch(
      this.props.keyword,
      this.props.selectedResearchType,
      this.props.seoDb,
      this.props.offset
    );
  }

  render() {
    return (
      <KeywordResearchTable
        keywords={this.props.keywords}
        hasMore={this.props.hasMore}
        onLoadMore={this.onLoadMore}
        isLoading={this.props.isLoading}
        isFirstFetch={this.props.isFirstFetch}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyword, seoDb } = ownProps;
  return {
    keywords: getKeywordResearchKeywords(state, keyword, seoDb),
    hasMore: getKeywordResearchHasMore(state, keyword, seoDb),
    isLoading: isFetchingKeywordResearch(state, keyword, seoDb),
    offset: getOffset(state, keyword, seoDb),
    isFirstFetch: isFirstFetch(state, keyword, seoDb),
    selectedResearchType: getSelectedResearchType(state),
    keywordResearch: getKeywordResearchData(state)
  };
};

export default connect(mapStateToProps, { fetchKeywordResearch })(KeywordResearchTableContainer);
